<header class="col-12 header-page">
  <section class="col-7 px-0">
    <h1 class="header__page__content__title">Histórico de Reembolso</h1>
  </section>
  <section class="col-5 float-right px-sm-0">
    <button class="btn btn-outline-primary float-right" [routerLink]="['/reembolso']">Voltar</button>
  </section>
</header>

<ng-template #showLoading>
  <spinner [show]="true"></spinner>
</ng-template>

<ng-template #NaoPossuiReembolso>
  <p class="col-12 ng-template-text">Você não possui reembolsos disponíveis!</p>
</ng-template>

<main class="col-12 main__content">
  <section>
    <form class="content__form px-0" [formGroup]="formData">
      <section class="row section-pd">
        <div class="col-md-6 px-1 mb-2">
          <label class="labelFiltro">Quem utilizou?</label>
          <ng-select bindLabel="name" bindValue="id" [searchable]="false" placeholder="Selecione um beneficiário"
            formControlName="beneficiaryId" notFoundText="Não há items" loadingText="Carregando..."
            [items]="beneficiaries">
          </ng-select>
        </div>
        <div class="col-md-6 px-1 mb-2">
          <label class="labelFiltro">Tipo de reembolso</label>
          <ng-select [items]="refundTypes" bindLabel="description" bindValue="id" [searchable]="false"
            placeholder="Todos" formControlName="refundTypeId" notFoundText="Não há items" loadingText="Carregando...">
          </ng-select>
        </div>
        <div class="col-md-6 px-1 mb-2">
          <label class="labelFiltro">Situação</label>
          <ng-select [items]="refundStatus" bindLabel="description" bindValue="id" [searchable]="false"
            placeholder="Todos" formControlName="refundStatusId" notFoundText="Não há items"
            loadingText="Carregando...">
          </ng-select>
        </div>
        <div class="col-md-6 px-1 mb-2">
          <label class="labelFiltro">Protocolo de Atendimento</label>
          <input class="form-control input-form" formControlName="protocol" maxlength="25"
            placeholder="Ex: 706952394" type="text" step="1"
            onkeydown="if(event.key==='.'){event.preventDefault();}"
            oninput="event.target.value = event.target.value.replace(/[^0-9]*/g,'');">
        </div>
      </section>
    </form>
  </section>

  <section class="mt-2 col-12 p-0">
    <button type="submit" class="btn btn-primary col-xl-2 col-lg-3 col-md-4 col-sm-12" (click)="getFilter()">
      Pesquisar
    </button>
  </section>

  <section class="content__main" *ngIf="!loading; else showLoading" [@fadeIn]>
    <div class="content__header" *ngIf="myRefundRequests && myRefundRequests.items.length > 0 ">
      <filtro-dados [pageItens]="5" [totalItens]="myRefundRequests?.totalItems"
        (changeQuantidade)="onChangeQuantidadeItens($event)">
      </filtro-dados>
    </div>

    <section *ngIf="myRefundRequests">
      <!-- Tabela para desktop -->
      <div class="d-none d-md-flex content__header__table"
        *ngIf="myRefundRequests.items.length > 0 else NaoPossuiReembolso">
        <div class="col-xl-3">Protocolo</div>
        <div class="col-xl-3">Data e hora da solicitação</div>
        <div class="col-xl-2">Tipo de reembolso</div>
        <div class="col-xl-2">Situação</div>
        <div class="col-xl-2 text-center">Ações</div>
      </div>

      <!-- Itens como linha da tabela (desktop) -->
      <div class="table__card d-none d-md-flex"
        *ngFor="let item of myRefundRequests.items">
        <div class="col-xl-3">{{ item.ansProtocol }}</div>
        <div class="col-xl-3">{{ item.requestDate | date:'dd/MM/yyyy | HH:mm' || ' - '}}</div>
        <div class="col-xl-2">{{ item.refundType }}</div>
        <div class="col-xl-2">
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="4" [attr.fill]="getRefundStatusColor(item.refundStatusId)" />
          </svg>
          {{ item.refundStatus }}
        </div>
        <div class="col-xl-2 text-center content-acoes">
          <button class="tooltip-btn" title="Copiar Protocolo">
            <fa-icon class="fa-icon" [icon]="faCopy" (click)="copiarTexto(item.ansProtocol)" />
          </button>
          <button class="tooltip-btn" title="Visualizar Reembolso">
            <fa-icon class="fa-icon" [icon]="faEye" (click)="detalhesReembolso(item)" />
          </button>
        </div>
      </div>

      <!-- Itens como card (mobile) -->
      <div class="d-block d-md-none" *ngFor="let item of myRefundRequests.items">
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="card-title">Protocolo: {{ item.ansProtocol }}</h5>
            <p><strong>Data:</strong> {{ item.requestDate | date:'dd/MM/yyyy | HH:mm' || ' - ' }}</p>
            <p><strong>Tipo:</strong> {{ item.refundType }}</p>
            <p><strong>Situação:</strong>
              <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                <circle cx="10" cy="10" r="4" [attr.fill]="getRefundStatusColor(item.refundStatusId)" />
              </svg>
              {{ item.refundStatus }}
            </p>
            <div class="text-center">
              <button class="btn btn-sm btn-outline-secondary me-2" (click)="copiarTexto(item.ansProtocol)">
                Copiar
              </button>
              <button class="btn btn-sm btn-outline-info" (click)="detalhesReembolso(item)">
                Visualizar
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</main>

<footer *ngIf="myRefundRequests && myRefundRequests.items.length > 0  && !loading">
  <paginacao [currentPage]="1" [collectionSize]="myRefundRequests?.totalItems"
    [pageSize]="myRequestsFilter.itemsPerPage" (changeNumber)="onChangePagination($event)">
  </paginacao>
</footer>
